module.exports = __webpack_public_path__ + "static/media/Brightly_ios_1_preview.9302d516.jpg";